import { render, staticRenderFns } from "./prestock-add.vue?vue&type=template&id=4cac49b6&"
import script from "./prestock-add.vue?vue&type=script&lang=ts&"
export * from "./prestock-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports